import {useCallback} from 'react'
import useToast from 'hooks/useToast'
import {useAppDispatch} from 'state'
import {useTranslation} from 'contexts/Localization'
import {PRIORITIZED_CONNECTORS} from "~/utils/wallets/connections";
import useActiveWeb3React from "~/hooks/useActiveWeb3React";
import {ConnectionType} from '~/utils/wallets/config'
import {useAccount, useConnect, useDisconnect} from "wagmi";
import {SafeAppWeb3Modal} from '@safe-global/safe-apps-web3modal';

const useAuth = () => {
  const {connector: activeConnector, isConnected} = useAccount()
  const {connect, connectors, error, isLoading, pendingConnector} =
    useConnect()
  const {disconnectAsync} = useDisconnect()

  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const {chainId} = useActiveWeb3React()
  const {toastError} = useToast()

  // useEffect(() => {
  //     console.log('abc chainId', chainId)
  //     console.log('abc activeConnector', activeConnector)
  //     console.log('abc isConnected', isConnected)
  //     console.log('abc connectors', connectors)
  //     console.log('abc pendingConnector', pendingConnector)
  // }, [activeConnector, isConnected, connectors, pendingConnector]);

  const login = useCallback(
    async (connectionType: ConnectionType) => {
      const connector = PRIORITIZED_CONNECTORS[connectionType]

      if (activeConnector?.id !== connector.id) {
        await connect({chainId, connector})
        if (connector.id === 'safe') {
          const modal = new SafeAppWeb3Modal()
          // const modal = new SafeAppWeb3Modal({
          //     network: "fantosm",
          //     disableInjectedProvider: true,
          //     // providerOptions: {
          //     // }
          // });
          await modal.requestProvider()
          console.log('abc connected')

          /*
          // https://web3auth.io/docs/sdk/pnp/web/modal/initialize#arguments
          const options: Web3AuthOptions = {
              clientId: 'YOUR_WEB3_AUTH_CLIENT_ID', // https://dashboard.web3auth.io/
              web3AuthNetwork: 'mainnet',
              chainConfig: {
                  chainNamespace: CHAIN_NAMESPACES.EIP155,
                  chainId: '0x250',
                  // https://chainlist.org/
                  // rpcTarget: 'https://rpc.ankr.com/eth_goerli'
                  rpcTarget: getRpcUrl(chainId)
              },
              uiConfig: {
                  theme: 'dark',
                  loginMethodsOrder: ['google', 'facebook']
              }
          }

          // https://web3auth.io/docs/sdk/pnp/web/modal/initialize#configuring-adapters
          const modalConfig = {
              [WALLET_ADAPTERS.TORUS_EVM]: {
                  label: 'torus',
                  showOnModal: false
              },
              [WALLET_ADAPTERS.METAMASK]: {
                  label: 'metamask',
                  showOnDesktop: true,
                  showOnMobile: false
              }
          }

          // https://web3auth.io/docs/sdk/pnp/web/modal/whitelabel#whitelabeling-while-modal-initialization
          const openloginAdapter = new OpenloginAdapter({
              loginSettings: {
                  mfaLevel: 'mandatory'
              },
              adapterSettings: {
                  uxMode: 'popup',
                  whiteLabel: {
                      name: 'Safe'
                  }
              }
          })

          const web3AuthConfig: Web3AuthConfig = {
              txServiceUrl: 'https://safe-transaction-goerli.safe.global'
          }

          const web3AuthModalPack = new Web3AuthModalPack(web3AuthConfig)
          // @ts-ignore
          await web3AuthModalPack.init({options, adapters: [openloginAdapter], modalConfig})
          // await web3AuthModalPack.web3Auth.connect();
          await web3AuthModalPack.signIn()
          console.log('abc connected')
          */
        }
      }
      // window.location.reload()

//          if (connector) {
//                 if (connectionType === ConnectionType.INJECTED) {
//                     // connector.connector.activate(chainId)
//                 } else if (connectionType === ConnectionType.WALLET_CONNECT) {
//                     // connector.connector.activate(chainId)
//                 } else if (connectionType === ConnectionType.GNOSIS_SAFE) {
//                     // connector.connector.activate(chainId)
//                 }
//                 // } else {
      // activate(connector, async (error: Error) => {
      //   if (error instanceof UnsupportedChainIdError) {
      //     const hasSetup = await setupNetwork(chainId)
      //     if (hasSetup) {
      //       activate(connector)
      //     }
      //   } else {
      //     window.localStorage.removeItem(connectorLocalStorageKey)
      //     if (error instanceof NoEthereumProviderError || error instanceof NoBscProviderError) {
      //       toastError(t('Provider Error'), t('No provider was found'))
      //     } else if (
      //       error instanceof UserRejectedRequestErrorInjected ||
      //       error instanceof UserRejectedRequestErrorWalletConnect
      //     ) {
      //
      //       if (connector instanceof WalletConnectConnector) {
      //         const walletConnector = connector as WalletConnectConnector
      //         walletConnector.walletConnectProvider = null
      //       }
      //       toastError(t('Authorization Error'), t('Please authorize to access your account'))
      //     } else {
      //       toastError(error.name, error.message)
      //     }
      //   }
      // })
      // }
      //     } else {
      //         toastError(t('Unable to find connector'), t('The connector config is wrong'))
      //     }
    },
    [t, toastError],
  )

  const logout = useCallback(async () => {
    try {
      console.log("do disconnect")
      await disconnectAsync()
    } catch (error) {
      console.error(error)
    } finally {
      //clearUserStates(dispatch, { chainId: chain?.id })
    }
  }, [disconnectAsync, dispatch])

  return {login, logout}
}

export default useAuth
